// extracted by mini-css-extract-plugin
export default {"wrapper":"x5-z","play":"y5-z"};